import { Component, Input, OnInit } from '@angular/core';
import { postMessageToIframe } from 'src/app/_core/_function/postMessageToIframe';

@Component({
  selector: 'app-current-situation',
  templateUrl: './current-situation.component.html',
  styleUrls: ['./current-situation.component.scss']
})
export class CurrentSituationComponent implements OnInit {

  iframeElement: any;
  currentArrayScenes = ['011', 'current'];
  firstSceneArray = ['001', 'n'];
  currentScene: any = '';
  firstScene: any = '';

  @Input()
  public sceneTitleArray: any = [];
  isActivate: boolean = false;
  isActivateFirstScene: boolean = false;

  constructor() { }

  ngOnInit(): void {
    this.activateCurrentButton();
  }

  changeDirection(type) {
    let sceneName = '';
    if(type === 'currentScene') {
      sceneName = 'scene_' + this.currentScene;
      this.isActivateFirstScene = true;
    } else {
      sceneName = 'scene_' + this.firstScene;
      this.isActivateFirstScene = false;
    }
    
    const curDir = sceneName;
    const data = {
      scene: curDir, // pano ID
      autorotate: true,
    };

    postMessageToIframe(data);
  }

  activateCurrentButton() {
    this.currentArrayScenes.forEach(title => {
      this.sceneTitleArray.forEach(title2 => {
        if (title === title2) {
          this.currentScene = title2;
        }
      })
    })
    if (this.currentScene === '') {
      this.isActivate = false;
    } else {
      this.isActivate = true;
      this.activateFirstSceneButton();
    }
  }

  activateFirstSceneButton() {
    this.firstScene = this.sceneTitleArray[0];
    // this.firstSceneArray.forEach(title => {
    //   this.sceneTitleArray.forEach(title2 => {
    //     if (title === title2) {
    //       this.firstScene = title2;
    //     }
    //   })
    // })
  }
}
